module.exports = __webpack_public_path__ + "img/android3.99a846cf.jpeg";